import { BrokerId } from '../config/brokerImportGuides';
import { Transaction } from '../types';
import { parseGenericCsv } from './generic';
import { parseTrading212Csv } from './trading212';

export const parseCsv = (brokerType: BrokerId, csvText: string): Transaction[] => {
    if (brokerType === 'trading212') {
        return parseTrading212Csv(csvText);
    }
    return parseGenericCsv(csvText, brokerType);
};
